import { Box, Button, Grid } from "@mui/material";
import Input, { IOptions } from "../../../components/input/Input-v2";
import { LoadingButton } from "../../../components/button/Button";
import { SubmitHandler, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { IModelUser } from "../type/user.http";
import { useGetRoles } from "../network/resolver";
import { useUserInformation } from "../../../context/userInformation/UserInformationContext";
import Condition from "../../../components/condition/Condition";

interface IUserForm {
  id?: string;
  role?: number;
  name?: string;
  email?: string;
  isFetching?: boolean;
  isLoading?: boolean;
  onClose(): void;
  onSubmit(form: IModelUser): void;
}

type IFormInput = {
  role: IOptions;
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
};

export default function UserForm({
  onClose,
  onSubmit,
  isFetching,
  isLoading,
  email,
  name,
  role,
  id,
}: IUserForm) {
  const { handleSubmit, control, getValues, setValue } = useForm<IFormInput>();
  const { data: dataRawRole, isLoading: loadingRole } = useGetRoles();
  const [options, setOptions] = useState<IOptions[]>([]);
  const dataRole = dataRawRole?.data.data;
  const shouldWaitForFetch = isFetching || loadingRole;
  const { validateByRole } = useUserInformation();
  const isSuperAdmin = validateByRole("Super Admin");

  useEffect(() => {
    if (!dataRole) return;
    const newOptions = Object.entries(dataRole).map(([key, value]) => ({
      text: key,
      value,
    }));
    const selectedRole = Object.entries(dataRole).find(
      ([, value]) => value === role
    );
    if (selectedRole) {
      setValue("role", { text: selectedRole[0], value: selectedRole[1] });
    }
    setOptions(newOptions);
    setValue("email", email || "");
    setValue("name", name || "");
  }, [dataRole, role, name, email]);

  const onSubmitForm: SubmitHandler<IFormInput> = (data) => {
    let form: any = {
      name: data.name,
      email: data.email,
      password: data.password,
      role: data.role.value,
    };
    if (id) {
      form = { ...form, user_id: id };
    }
    onSubmit(form);
  };

  return (
    <Box p={1} pb={2} pt={2} bgcolor={"white"} borderRadius={2}>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <Grid container spacing={2}>
          <Condition.IF condition={isSuperAdmin}>
            <Grid item xs={12} lg={6}>
              <Input.Controller
                control={control}
                name="role"
                rules={{ required: "Kolom ini tidak boleh kosong" }}
                render={(field, fieldState) => (
                  <Input.Select
                    value={field.value}
                    label="Role"
                    isFetching={shouldWaitForFetch}
                    error={fieldState.error?.message}
                    onChange={(e) => field.onChange(e)}
                    options={options}
                  />
                )}
              />
            </Grid>
          </Condition.IF>

          <Grid item xs={12} lg={6}>
            <Input.Controller
              control={control}
              name="email"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  type="email"
                  label="Email"
                  isFetching={shouldWaitForFetch}
                  value={field.value}
                  error={fieldState.error?.message}
                  onChange={(e) => field.onChange(e)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <Input.Controller
              control={control}
              name="name"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Nama"
                  value={field.value}
                  isFetching={shouldWaitForFetch}
                  error={fieldState.error?.message}
                  onChange={(e) => field.onChange(e)}
                />
              )}
            />
          </Grid>
          <Condition.IF condition={isSuperAdmin}>
            <Grid item xs={12} lg={6}>
              <Input.Controller
                control={control}
                name="password"
                rules={{
                  required: !id ? "Kolom ini tidak boleh kosong" : false,
                }}
                render={(field, fieldState) => (
                  <Input.Text
                    type="password"
                    label="Password"
                    isFetching={shouldWaitForFetch}
                    value={field.value}
                    error={fieldState.error?.message}
                    onChange={(e) => field.onChange(e)}
                  />
                )}
              />
            </Grid>
          </Condition.IF>
          <Condition.IF condition={isSuperAdmin}>
            <Grid item xs={12} lg={6}>
              <Input.Controller
                control={control}
                name="confirmPassword"
                rules={{
                  required: !id ? "Kolom ini tidak boleh kosong" : false,
                  validate: (value) =>
                    value === getValues("password") || "Password Tidak Sama",
                }}
                render={(field, fieldState) => (
                  <Input.Text
                    type="password"
                    label="Confirm Password"
                    isFetching={shouldWaitForFetch}
                    value={field.value}
                    error={fieldState.error?.message}
                    onChange={(e) => field.onChange(e)}
                  />
                )}
              />
            </Grid>
          </Condition.IF>
          <Grid
            item
            xs={12}
            lg={12}
            mt={1}
            gap={1}
            display={"flex"}
            justifyContent={"end"}
          >
            <Button onClick={onClose}>Cancel</Button>
            <LoadingButton type="submit" text="Sumbit" isLoading={isLoading} />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
